<template>
    <div class="generator-box" ref="screenShotBox">
        <div v-if="null != obj && obj.tag == 'companyname'" class="company-name-pad">
            <span :style="{'font-size': fontsize}">{{obj.companyname}}</span>
        </div>
    </div>
</template>

<script setup>
    import html2canvas from 'html2canvas';
    import {onMounted, getCurrentInstance, computed} from "vue";

    const props = defineProps(["obj"])
    const emits = defineEmits(["success-complete"])

    const { proxy } = getCurrentInstance()

    const fontsize = computed(() => {
        let num = 80

        if (null != props.obj && null != props.obj.companyname){
            num = Math.floor(480 / props.obj.companyname.length)

            if (num > 80){
                num = 80
            }
        }

        num += "px"

        return num

    })

    async function screenShot(){
        // html2canvas(proxy.$refs.screenShotBox,{timeout: 250, width: 425, height: 275, dpi: 320})
        html2canvas(proxy.$refs.screenShotBox,{timeout: 250})
            .then(canvas => { //scala默认1 控制字体线条粗细
                // var context = canvas.getContext("2d")
                // context.drawImage(canvas, 0, 0, 425, 275)
                // var data = context.getImageData(0, 0, 425, 275)
                // canvas.width = 425
                // canvas.height = 275
                // context.putImageData(data, 0, 0)
                // context.drawImage(canvas, 0, 0, 425, 275)
                // value.memberworkImgFile = canvas.toDataURL("image/jpeg", 0.8)
                // box.remove()
                // update(value)
                const imgBase64 = canvas.toDataURL("image/jpeg")

                emits("success-complete", props.obj, imgBase64)

            });
    }

    onMounted(() => {
        if (null != props.obj){
            screenShot()
        }
    })

</script>

<style scoped>
    .generator-box {
        position: fixed;
        left: 0;
        top: 200vh;

    }

    .company-name-pad {
        text-align: center;
        width: 500px;
        height: 100px;
        font-size: 36px;
        background: linear-gradient(45deg, #708090, #7c8ea0) !important;
        color: #fff !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>